module.exports = __webpack_public_path__ + "img/24.1.2ffe6923.jpg";